import { FC, FormEvent, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import Button from '@z-components/atoms/Button';
import InputBox from '@z-components/atoms/InputBox';

import styles from './RequestFormEntryForm.module.scss';

interface Props {
  isZipcodeInputShown?: boolean;
  label: string;
  onSubmit: (address: string) => void;
}

const RequestFormEntryForm: FC<Props> = ({ isZipcodeInputShown = true, label, onSubmit }) => {
  const { t } = useTranslation();
  const [zipCode, setZipCode] = useState('');
  const handleSubmit = useCallback(
    (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      onSubmit(isZipcodeInputShown ? zipCode : '');
    },
    [isZipcodeInputShown, onSubmit, zipCode]
  );

  return (
    <form className={styles.container} noValidate={true} onSubmit={handleSubmit}>
      {isZipcodeInputShown ? (
        <InputBox
          centerLabel={true}
          isLong={true}
          label={label}
          name="zipcode"
          // eslint-disable-next-line react/jsx-no-bind
          onChange={(event) => setZipCode(event.target.value)}
          placeholder={t('marketingPages:requestFormEntryForm.placeholder')}
        />
      ) : (
        <p className={styles.label}>{label}</p>
      )}

      <Button
        className={classNames(styles.button, 'z-btn z-btn-full z-btn-action')}
        id="startNewRequstBtn"
        testId="start-new-request"
        text={t('marketingPages:requestFormEntryForm.findPro')}
        type="submit"
      />
    </form>
  );
};

export default RequestFormEntryForm;
